import * as React from "react";

const SvgChainedEvent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <mask
      id="chained_event_svg__a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="currentColor" fillOpacity={0.92} d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#chained_event_svg__a)">
      <path
        fill="currentColor"
        d="M7.757 14.829 4.93 12q-1.467-1.467-1.467-3.536T4.929 4.93t3.535-1.467q2.07 0 3.536 1.467l2.828 2.828-1.414 1.415-2.828-2.829a2.9 2.9 0 0 0-2.122-.884q-1.237 0-2.12.884a2.9 2.9 0 0 0-.885 2.121q0 1.238.884 2.122l2.829 2.828zm.707-4.95L9.88 8.464l5.657 5.657-1.415 1.415zm.708 6.364 1.414-1.414 2.828 2.828q.885.885 2.122.884 1.237 0 2.12-.884.885-.885.885-2.121 0-1.237-.884-2.122l-2.829-2.828 1.415-1.414L19.07 12q1.467 1.467 1.467 3.536 0 2.067-1.467 3.535t-3.536 1.467q-2.067 0-3.535-1.467z"
      />
    </g>
  </svg>
);
export default SvgChainedEvent;
